import * as R from "ramda";

const getOrderDetail = (state: any) =>
  R.pathOr([], ["PurchaseOrder", "orderDetail"], state);
const getPoolGridData = (state: any) =>
  R.pathOr([], ["PurchaseOrder", "poolGridData"], state);
const getPurchaseTypeDropdown = (state: any) =>
  R.pathOr([], ["PurchaseOrder", "purchaseType"], state);
const getRegisteredDropdown = (state: any) =>
  R.pathOr([], ["PurchaseOrder", "registered"], state);
const getOrderTypeDropdown = (state: any) =>
  R.pathOr([], ["PurchaseOrder", "orderType"], state);
const getClientCodeDropdown = (state: any) =>
  R.pathOr([], ["PurchaseOrder", "clientCode"], state);
const getReasonCodeDropdown = (state: any) =>
  R.pathOr([], ["PurchaseOrder", "reasonCode"], state);
const getFleetRequestDetailData = (state: any) =>
  R.pathOr([], ["PurchaseOrder", "fleetRequestDetailData"], state);
const getCapexDropdown = (state: any) =>
  R.pathOr([], ["PurchaseOrder", "capexType"], state);
const getAssignToDropdown = (state: any) =>
  R.pathOr([], ["PurchaseOrder", "assignTo"], state);
const getVendorDetails = (state: any) =>
  R.pathOr({}, ["PurchaseOrder", "vendorDetails"], state);
const getPurchaseOrderStepperData = (state: any) =>
  R.pathOr({}, ["PurchaseOrder", "purchaseOrderStepperData"], state);
const getError = (state: any) =>
  R.pathOr(undefined, ["PurchaseOrder", "error"], state);
const getChangeLogs = (state: any) => 
  R.pathOr([], ["PurchaseOrder", "changeLogs"], state)

const getEqClassCodeDropdown = (state: any) =>
  R.pathOr([], ["PurchaseOrder", "eqClassCodeDropdown"], state);

const selectors = {
  getOrderDetail,
  getPoolGridData,
  getPurchaseTypeDropdown,
  getRegisteredDropdown,
  getOrderTypeDropdown,
  getClientCodeDropdown,
  getReasonCodeDropdown,
  getFleetRequestDetailData,
  getCapexDropdown,
  getAssignToDropdown,
  getVendorDetails,
  getPurchaseOrderStepperData,
  getError,
  getChangeLogs,
  getEqClassCodeDropdown
};

export default selectors;
